export var Platforms;
(function (Platforms) {
    Platforms["donor"] = "DONOR";
    Platforms["charity"] = "CHARITY";
    Platforms["admin"] = "ADMIN";
    Platforms["customer_service"] = "CUSTOMER_SERVICE";
})(Platforms || (Platforms = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxhdGZvcm1zLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInBsYXRmb3Jtcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxTQUtYO0FBTEQsV0FBWSxTQUFTO0lBQ25CLDRCQUFlLENBQUE7SUFDZixnQ0FBbUIsQ0FBQTtJQUNuQiw0QkFBZSxDQUFBO0lBQ2Ysa0RBQXFDLENBQUE7QUFDdkMsQ0FBQyxFQUxXLFNBQVMsS0FBVCxTQUFTLFFBS3BCIn0=